import { render } from "./CompanyType.vue?vue&type=template&id=80775896"
import script from "./CompanyType.vue?vue&type=script&lang=js"
export * from "./CompanyType.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__